angular.module('gym.mobile_app').directive('mobileAppSettingsFeatures', function() {
  return {
    restrict: 'E',
    template: require('templates/gyms/mobile_app/features.html.slim'),
    controller: ["$scope", "$rootScope", "MobileApp", "MasqueradingService", "flash", "$window", "$q", function($scope, $rootScope, MobileApp, MasqueradingService, flash, $window, $q) {
      var onEditEnd;
      $scope.gym = $rootScope.gym;
      $scope.isMasquerading = MasqueradingService.isMasquerading();
      $scope.features = {};
      $scope.fetchSettings = function() {
        var loadPromise;
        loadPromise = [MobileApp.all('settings').doGET('meta'), MobileApp.all('settings').getList()];
        return $q.all(loadPromise).then(function(response) {
          $scope.meta = response[0];
          $scope.settings = response[1][0];
          $scope.settings.rootObjectName = 'gym_mobile_app_detail';
          $scope.settings.copy_changes_to_contacts = '1';
          return $scope.meta.features_available_to_gym.forEach(function(feature) {
            return $scope.features[feature] = $scope.settings.features_disabled.indexOf(feature) === -1;
          });
        });
      };
      $scope.fetchSettings();
      $scope.onFeatureToggle = function(feature) {
        $scope.onEditStart();
        return $scope.settings.features_disabled = $scope.features[feature] ? _.without($scope.settings.features_disabled, feature) : $scope.settings.features_disabled.concat(feature);
      };
      $scope.onEditStart = function() {
        var confirmText;
        confirmText = 'You have unsaved changes. Are you sure you want to leave this page?';
        $rootScope.stateChangeConfirmMessage = confirmText;
        return $window.onbeforeunload = function(e) {
          e.returnValue = confirmText;
          return confirmText;
        };
      };
      onEditEnd = function() {
        $rootScope.stateChangeConfirmMessage = void 0;
        return $window.onbeforeunload = void 0;
      };
      return $scope.save = function() {
        var message;
        message = 'Please confirm your choices before continuing.';
        if ($window.confirm(message)) {
          $scope.loading = true;
          return $scope.settings.save().then(function(data) {
            $scope.loading = false;
            $scope.settings = data;
            $scope.settings.rootObjectName = 'gym_mobile_app_detail';
            $scope.settings.copy_changes_to_contacts = '1';
            flash.success = 'Features updated successfully';
            onEditEnd();
            return $scope.fetchSettings();
          }, function() {
            flash.error = "There was an error processing the request.";
            return $scope.loading = false;
          });
        }
      };
    }]
  };
});
